import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Ignore errors injected by browser extensions (e.g. MetaMask) that are
// unrelated to this app and would otherwise clutter the console / dev overlay.
const isExtensionNoise = (msg, src) => {
  const text = `${msg || ""} ${src || ""}`.toLowerCase();
  return text.includes("chrome-extension://") || text.includes("metamask") ||
    text.includes("failed to connect to metamask") || text.includes("inpage.js");
};
window.addEventListener("error", (e) => {
  if (isExtensionNoise(e?.message, e?.filename)) { e.stopImmediatePropagation(); }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const r = e?.reason;
  if (isExtensionNoise(typeof r === "string" ? r : r?.message, r?.stack)) { e.preventDefault(); }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
